import { HttpClient } from '@angular/common/http';
import { ApiResult } from '@app/lib/shared/api.result';
import { environment } from '@env/environment';
import { ApiClientConfig } from '../api-client.config';
import { FeeForm, FeeProfile, FeeSection, FeeUpdate, ModuleEnum } from './api.fee.models';

const FEE_PATH = '/billing/';

export class FeeApi {
  private apiUrl: string = environment.API_URL;

  constructor(
    public http: HttpClient,
    public config: ApiClientConfig
  ) { }

  getFeesByModule(module: ModuleEnum, profileName: string) {
    return this.http.get<FeeSection>(
      `${this.apiUrl}${FEE_PATH}${module}/default/profiles/${encodeURIComponent(profileName)}`
    );
  }

  getFeesByModuleAndRegion(module: ModuleEnum, regionId: string, profileName: string) {
    return this.http.get<FeeSection>(
      `${this.apiUrl}${FEE_PATH}${module}/region/${regionId}/profiles/${encodeURIComponent(profileName)}`
    );
  }

  updateFee(id: string, body: FeeUpdate) {
    return this.http.put(`${this.apiUrl}${FEE_PATH}region/${id}`, body);
  }

  createFee(module: ModuleEnum, body: FeeForm) {
    return this.http.post(`${this.apiUrl}${FEE_PATH}${module}`, body);
  }

  getProfilesByModule(module: ModuleEnum) {
    return this.http.get<FeeSection>(`${this.apiUrl}${FEE_PATH}${module}/profiles`);
  }

  createProfilesByModule(body: { name: string; module: ModuleEnum }) {
    return this.http.post<ApiResult.ApiResponse<FeeProfile>>(
      `${this.apiUrl}${FEE_PATH}profiles`,
      body
    );
  }
}
